import { callExternalApi } from "./external-api.service";

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL;



export const createOrUpdateRSVP = async (accessToken, formData, id = null) => {
  const config = {
    url: id ? `${apiServerUrl}/api/rsvp/update/${id}` : `${apiServerUrl}/api/rsvp/new`,
    method: id ? "PUT" : "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    data: formData
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
}